export default "__VITE_ASSET__BOgv3Ijw__"